var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMessage)?_c('div',{staticClass:"global-message"},[_vm._v(" 请切换到极速模式以获得更好的浏览体验！ ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }